export const CONTRACT_REVIEW_SEVERITIES = ['high', 'medium', 'low'] as const;

export type ContractReviewSeverity = (typeof CONTRACT_REVIEW_SEVERITIES)[number];

export const getDeviationSeverityFromScore = (score: number): ContractReviewSeverity => {
  if (score >= 5) return 'high';
  if (score >= 4) return 'medium';
  return 'low';
};

export const getClusterSeverity = (cluster: {
  evidenceRedFlag: string | null;
  evidenceNeedsReview: string | null;
}): ContractReviewSeverity => {
  if (cluster.evidenceRedFlag) return 'high';
  if (cluster.evidenceNeedsReview) return 'medium';
  return 'low';
};

export const countClusterSeverities = (
  clusters: { evidenceRedFlag: string | null; evidenceNeedsReview: string | null }[],
) => {
  const counts: Record<ContractReviewSeverity, number> = { high: 0, medium: 0, low: 0 };
  for (const cluster of clusters) counts[getClusterSeverity(cluster)]++;
  return counts;
};

export const SEVERITY_TEXT = {
  high: { en: 'Red flag', nb: 'Rødt flagg' },
  medium: { en: 'Needs review', nb: 'Trenger gjennomgang' },
  low: { en: 'Minor issues', nb: 'Mindre avvik' },
};

export const PRIORITY_TEXT = {
  high: { en: 'High', nb: 'Høy' },
  medium: { en: 'Medium', nb: 'Middels' },
  low: { en: 'Low', nb: 'Lav' },
};

export const DEVIATION_SEVERITY_BADGE_VARIANT = {
  high: 'tertiary-destructive',
  medium: 'tertiary-warning',
  low: 'tertiary-success',
} as const;

export const REDLINE_OPERATION_TEXT = {
  replace: { en: 'Replace', nb: 'Erstatt' },
  delete: { en: 'Delete', nb: 'Slett' },
  insert_before: { en: 'Insert before', nb: 'Sett inn før' },
  insert_after: { en: 'Insert after', nb: 'Sett inn etter' },
};

export const TEMPLATE_VERDICT_TEXT = {
  adverse_trigger: { en: 'Adverse term identified', nb: 'Ugunstig vilkår identifisert' },
  no_adverse_trigger_found: {
    en: 'No adverse term identified',
    nb: 'Ingen ugunstige vilkår identifisert',
  },
  unresolved: { en: 'Unresolved', nb: 'Uavklart' },
  not_applicable: { en: 'Not applicable', nb: 'Ikke relevant' },
  potential_trigger: { en: 'Potential issue', nb: 'Mulig problem' },
};
